import api from "@/config/api";
import { ReportsPagedResponse } from "@/types/report";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Params } from "@/types/utils";

type QueryArgs = {
    reviewStatus: string;
};

const useQueryReports = ({ reviewStatus }: QueryArgs) => {
    const { oid } = useParams<Params>();
    const enabled = !!oid;

    const fetchReports = async () => {
        const data = await api.get<ReportsPagedResponse>(
            `/organizations/${oid}/reports/paged?reviewStatus=${reviewStatus}`,
        );
        return data;
    };

    return useQuery({
        queryKey: ["reports", oid, reviewStatus],
        queryFn: fetchReports,
        enabled,
        placeholderData: keepPreviousData,
    });
};

export default useQueryReports;
